import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Paper,
} from "@mui/material";
import { Add, Edit, Delete, Close } from "@mui/icons-material";
import "./FinanceComponent.css";

const emptyForm = {
  componentName: "",
  type: "",
  frequency: "",
  taxable: "",
  annualLimit: "",
  individualOverride: "",
  esiApplicable: "",
  proofRequired: "",
  includedInCTC: "",
  appliedTo: "",
  basic: "",
  hra: "",
};

const dummyData = [
  {
    componentName: "Basic Salary",
    type: "Earning",
    frequency: "Monthly",
    taxable: "Yes",
    annualLimit: "No Limit",
    individualOverride: "No",
    esiApplicable: "Yes",
    proofRequired: "No",
    includedInCTC: "Yes",
    appliedTo: "All Employees",
    basic: "100%",
    hra: "0%",
  },
  {
    componentName: "House Rent Allowance",
    type: "Earning",
    frequency: "Monthly",
    taxable: "Partially",
    annualLimit: "₹ 1,50,000",
    individualOverride: "Yes",
    esiApplicable: "No",
    proofRequired: "Yes",
    includedInCTC: "Yes",
    appliedTo: "Urban Employees",
    basic: "0%",
    hra: "40%",
  },
];

const FinanceComponent = () => {
  const [data, setData] = useState(dummyData);
  const [form, setForm] = useState(emptyForm);
  const [open, setOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  const openModal = (row = null, index = null) => {
    setForm(row || emptyForm);
    setEditIndex(index);
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setForm(emptyForm);
    setEditIndex(null);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    if (Object.values(form).some((v) => v === "")) {
      alert("All fields are required");
      return;
    }

    if (editIndex !== null) {
      const updated = [...data];
      updated[editIndex] = form;
      setData(updated);
    } else {
      setData([...data, form]);
    }
    closeModal();
  };

  const handleDelete = (index) => {
    if (window.confirm("Delete this component?")) {
      setData(data.filter((_, i) => i !== index));
    }
  };

  return (
    <div className="finance-wrapper">
      <div className="finance-card">
        <div className="finance-header">
          <h2>Finance Components</h2>
          <Button
            className="finance-add-btn"
            startIcon={<Add />}
            onClick={() => openModal()}
          >
            Add Component
          </Button>
        </div>

        <TableContainer component={Paper} className="finance-table">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>S.No</TableCell>
                <TableCell>Component Name</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Frequency</TableCell>
                <TableCell>Taxable</TableCell>
                <TableCell>Annual Limit</TableCell>
                <TableCell>Included in CTC</TableCell>
                <TableCell align="center">Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {data.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.componentName}</TableCell>
                  <TableCell>{row.type}</TableCell>
                  <TableCell>{row.frequency}</TableCell>
                  <TableCell>{row.taxable}</TableCell>
                  <TableCell>{row.annualLimit}</TableCell>
                  <TableCell>{row.includedInCTC}</TableCell>
                  <TableCell align="center">
                    <IconButton
                      color="warning"
                      onClick={() => openModal(row, index)}
                    >
                      <Edit />
                    </IconButton>
                    <IconButton
                      color="error"
                      onClick={() => handleDelete(index)}
                    >
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

              {!data.length && (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    No finance components found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {/* MODAL */}
      <Modal open={open} onClose={closeModal}>
        <Box className="finance-modal">
          <div className="modal-header">
            <h3>Finance Component Entry</h3>
            <IconButton onClick={closeModal}>
              <Close />
            </IconButton>
          </div>

          <div className="modal-grid">
            {Object.keys(emptyForm).map((key) => (
              <TextField
                key={key}
                label={key.replace(/([A-Z])/g, " $1")}
                name={key}
                value={form[key]}
                onChange={handleChange}
                size="small"
              />
            ))}
          </div>

          <Button className="finance-save-btn" onClick={handleSave}>
            Save
          </Button>
        </Box>
      </Modal>
    </div>
  );
};

export default FinanceComponent;
